import React from 'react';
import PropTypes from 'prop-types';

import { Theme } from '@styles';

// Apex Charts
import Chart from 'react-apexcharts';

const DonutChart = (props) => {
  const { colors, labels, height, series, totalLabel } = props;

  // Apex Chart Options
  const options = {
    colors,
    labels,
    dataLabels: {
      enabled: false
    },
    fill: {
      type: 'gradient',
    },
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
      fontFamily: 'Bryant Pro Regular',
      fontSize: Theme.typography.bodyText,
      labels: {
        colors: Theme.colors.greyDark,
        useSeriesColors: false
      },
      markers: {
        width: 12,
        height: 12,
        radius: 12,
        strokeWidth: 1,
        strokeColor: Theme.colors.white,
      },
      itemMargin: {
        horizontal: 16,
        vertical: 0
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: '88%',
          background: 'transparent',
          labels: {
            show: true,
            value: {
              show: true,
              fontFamily: 'Bryant Pro Medium',
              fontSize: Theme.typography.heading2,
              color: Theme.colors.greyDark,
              offsetY: 8,
            },
            total: {
              show: true,
              showAlways: false,
              label: totalLabel,
              fontFamily: 'Bryant Pro Medium',
              fontSize: Theme.typography.heading6,
              color: Theme.colors.greyDark,
            }
          }
        }
      }
    },
    stroke: {
      width: 0,
    },
    tooltip: {
      style: {
        fontFamily: 'Bryant Pro Regular',
        fontSize: Theme.typography.smallText,
      }
    }
  };

  return (
    <Chart
      height={height}
      options={options}
      series={series}
      type="donut"
    />
  );
};

DonutChart.propTypes = {
  // Arreglo de colores para la gráfica.
  colors: PropTypes.array.isRequired,
  // Etiquetas de los datos a mostrar en la gráfica.
  labels: PropTypes.array.isRequired,
  // Altura de la gráfica.
  height: PropTypes.number.isRequired,
  // Datos de la gráfica.
  series: PropTypes.array.isRequired,
  // Etiqueta a mostrar en la gráfica.
  totalLabel: PropTypes.string,
};

export default DonutChart;
